export const HowToPlay = {
  Title: "How to play? It's quite simple...",
  Tutorial:
    "You have to guess today's randomly generated POKéMON from the POKéMON franchise, it changes every 24 hours.",
  Tutorial2:
    'Just simply type the name of a POKéMON in the input and it will reveal some properties.',
  Tutorial3:
    'The color of the boxes will change depending on how close your guess was to the random POKéMON to find.',
  TutorialCry:
    "In Cry mode, you have to guess the POKéMON by listening to its cry, in the least number of tries. You'll get a clue every 3 tries.",
  TutorialCry2: 'You can listen to it as many times as you want.',
  TutorialEmoji:
    'In Emoji mode, try to guess which POKéMON corresponds to the sequence of emojis. Each guess reveals a new one.',

  IndicationsGreen: 'Indicates the property is an exact match.',
  IndicationsYellow:
    'In the TYPES and ABILITIES properties, indicates the property is a partial match. In case of the other properties, indicates that is very close to the answer.',
  IndicationsRed: 'Indicates the property is not a match.',
  ValuesTitle: 'Possible values: ',

  IndicationsArrow:
    '⭡ ⭣ Arrows indicates if the answer property is higher or lower than your guess.',
  PropertiesTitle: 'The properties are the following:',
  PropertiesGen: 'The generation in which the POKéMON was released.',
  PropertiesGenValues:
    '1, 2, 3, 4... This website is still in development, so for now there is a total of 493 POKéMON.',
  PropertiesTypes:
    'The type of the POKéMON. There are 18 types in total, and POKéMON can have 1 or 2 types.',
  PropertiesTypesValues:
    'Normal, Fire, Water, Electric, Grass, Ice, Fighting, Poison, Ground, Flying, Psychic, Bug, Rock, Ghost, Dragon, Dark, Steel, Fairy.',
  PropertiesAbilities:
    'POKéMON have multiple possible Abilities, the most abilities any species has is three.',
  PropertiesAbilitiesValues: 'Air Lock, Arena Trap, Battle Armor, etc...',
  PropertiesWeight: 'The weight of the POKéMON in kilograms.',
  PropertiesWeightValues: '0.1, 0.2, 0.3... 950.0.',
  PropertiesHeight: 'The height of the POKéMON in meters.',
  PropertiesHeightValues: '0.2, 0.3, 0.4... 14.5.',
  PropertiesStats:
    'The total sum of the base stats of the POKéMON, so the higher the number, the stronger the POKéMON.',
  PropertiesStatsValues: '180, 181, 182... 720.',
};

export const About = {
  Daily: 'Guess daily POKéMON from the Pokémon franchise.',
  Content: 'All content is © Nintendo, Game Freak, and The Pokémon Company.',
  Project: 'This project is incredibly inspired by this cool game called',
  Questions: 'Have any questions? Send a mail to:',
  Mail: 'flaviortodoxo@gmail.com',
  End: 'Have fun! - rotincol 😁',
};
